module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA8AAAAQCAYAAADJViUEAAABNklEQVQ4T83TPUsWUBjG8d/Vmwh9iJBs6SvUYEsRouAWzi6B+A1KW5qEooKipU8QBEpjRJROjrVZUEOUS4MFUt5x4BQPD89Djh04yzn3/7rfY8SpqjncwhRe43qS98OmGX6oqgt4hS28wTUc4lySH4P2qaqTmET1+xAzOIsTON+Fmshmhw+T7Dd4F2c62P6O4Rf+RNVEjw+IN5ufSSYavNBzW8U2dgbAwShbFCt4irdJbvzNuar2cDPJgzFFnMB3zCfZaDbD8GqS+2Pg0/iGhSTPxsJVdRHvkuxV1Tye49RR4c94jDto6Vzt7TuS508dbvl/xZU+LP85/AWPcLeHPYuX/yrYWpJ7VbXY5/oDlvEEB9gf16qPaB7XRy0aprGGS0leDPd5CbfRhmHUafPetuxykrZlfgOoCLERcZ+kugAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/delete.png
// module id = 0/ev
// module chunks = 2